$(document).ready(function() {
    var owl = $('.discount-code-desc-main.offer_slider');
    owl.owlCarousel({
        loop: true,
        margin: 10,
        items: 1,
        autoplay: true,
        nav: false,
        dots: true
    });

    var block = false;
    $(".discount-code-desc-main.offer_slider .owl-item").mouseenter(function() {
        if (!block) {
            block = true;
            owl.trigger('stop.owl.autoplay')
            block = false;
        }
    });
    $(".discount-code-desc-main.offer_slider .owl-item").mouseleave(function() {
        if (!block) {
            block = true;
            owl.trigger('play.owl.autoplay', [3000])
            block = false;
        }
    });
    $(document).on('click', '.cust-accordion .acco-title', function(e) {
        e.preventDefault();
        $(this).toggleClass('active').siblings('.acco-content').slideToggle();
    })

    $('.codecopy-loader').hide();
    $(document).on('click', 'div.discount-code-snippet .discount-code', function(e) {
        e.preventDefault();
        var current = $(this).siblings('.discount-success-msg');
        var curr = $(this).children('span');
        var discount_code = $(this).data('id');
        var loaderclass = $(this).siblings('.codecopy-loader');
        $.ajax({
            url: `/discount/${discount_code}`,
            method: 'GET',
            beforeSend: function() {
                $(loaderclass).show();
                $(current).hide();
            },
            success: function() {
                $(loaderclass).hide();
                $(current).show();
                $(current).html('Code applied');
                $(curr).removeClass('before-apply');
                $(curr).addClass('after-apply');
            }
        })
    });
})